<template>
  <v-content style="height: 100%;">
    <v-container
      class="fill-height align-stretch"
      fluid
      v-on:keydown.enter="submitHandler"
    >
      <v-row
        class="d-flex align-stretch"
      >
        <v-col
          class="d-flex align-center justify-center"
          cols="6"
               sm="6"
               md="6"
        >
          <img alt="company logo" class="logo img-responsive" :src="logoPath">
        </v-col>
        <v-col
          class="d-flex align-center grey lighten-2 justify-center"
          cols="6"
          sm="6"
          md="6"
        >
          <v-col align="center"
                 justify="center">
            <v-card class="form-container">
              <v-progress-linear value="0" height="4" indeterminate :active="$store.state.auth.isLoggingIn"></v-progress-linear>
              <v-card-text>
                <v-form ref="loginForm">
                  <v-text-field
                    label="Email"
                    name="email"
                    prepend-icon="mdi-email"
                    type="text"
                    autocomplete="off"
                    v-model="email"
                    :rules="emailRules"
                  />

                  <v-text-field
                    id="password"
                    label="Password"
                    name="password"
                    prepend-icon="mdi-lock"
                    type="password"
                    v-model="password"
                    :rules="passwordRules"
                    @keypress="detectCapsLock"
                  />
                  <p class="pass-message">{{ showMessage }}</p>
                </v-form>
              </v-card-text>
              <v-card-actions class="d-flex justify-center px-5">
                <v-btn text small dense class="pa-0" :to="{name:'resetPassword'}">
                  Reset password
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn color="primary" type="submit" @click="submitHandler">Sign in</v-btn>
              </v-card-actions>
            </v-card>
          </v-col>

        </v-col>
      </v-row>
    </v-container>
  </v-content>
</template>

<script>
  import { mapActions } from 'vuex'
  import validationRules from '@/common/validationRules'
  export default {
    data: () => ({
      email: '',
      emailRules: validationRules.email,
      password: '',
      passwordRules: validationRules.password,
      logoPath: require('@/assets/logo.png'),
      showMessage: ''
    }),
    methods: {
      ...mapActions(['login']),
       submitHandler: async function () {
        if (!this.$refs.loginForm.validate()) {
          return
        }
        const formData = {
          email: this.email,
          password: this.password
        }
        this.login(formData)
      },
      detectCapsLock: function (event) {
        if (event && event.getModifierState('CapsLock')) {
          this.showMessage = 'Looks like your CAPS LOCK is on'
        } else {
          this.showMessage = ''
        }
      }
    }
  }
</script>

<style scoped>
  .logo {
    width: 380px;
  }
  .form-container {
    max-width: 500px;
  }
  .fill-height {
    padding: 0;
  }
  .row {
    margin-left: 0;
  }
  .pass-message {
    margin-bottom: 0;
    text-align: right;
    margin-top: -19px;
    font-size: 12px;
  }
</style>
